import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/durability.gif'
import icon3 from '../images/icon/digital-tra.gif'
import icon4 from '../images/icon/business-develop.gif'
import icon5 from '../images/icon/search.gif'
import icon6 from '../images/icon/warning.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/da-fea_icon01.svg'
import sdicon2 from '../images/icon/da-fea_icon02.svg'
import sdicon3 from '../images/icon/da-fea_icon03.svg'
import sdicon4 from '../images/icon/da-fea_icon04.svg'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'


import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'


import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'



const Services = [
    {
        Id: '1',
        sImg: icon1,
        title: 'Event Platform for Hosting Events',
        slug: 'Event-Platform',
        thumb1: 'Events',
        thumb2: 'Payments',
        description: 'Our event platform simplifies hosting with secure, selfie-verified ticket sales and custom payment flows—perfect for clubs, gigs, or festivals.',
    },
    
    {
        Id: '2',
        sImg: icon2,
        title: 'Booking Platform',
        slug: 'Booking-Platform',
        thumb1: 'Reservations',
        thumb2: 'Security',
        description: 'A tailored booking solution with built-in user verification to protect your business and ensure every reservation is legit.',
    },
    
    {
        Id: '3',
        sImg: icon3,
        title: 'Membership Platform',
        slug: 'Membership-Platform',
        thumb1: 'Subscriptions',
        thumb2: 'Trust',
        description: 'Manage memberships effortlessly with recurring payments secured by our selfie-check system—keeping your community safe and engaged.',
    },
    
    {
        Id: '4',
        sImg: icon4,
        title: 'EPOS Ticketing Integrations',
        slug: 'EPOS-Integrations',
        thumb1: 'Retail',
        thumb2: 'Seamless',
        description: 'Integrate AllGuard with your EPOS system for fast, secure in-store payments that sync with online sales.',
    },
    
    {
        Id: '5',
        sImg: icon5,
        title: 'Kiosk Ticketing Development',
        slug: 'Kiosk-Development',
        thumb1: 'Hardware',
        thumb2: 'Custom',
        description: 'Bespoke kiosk solutions with selfie-verified payments, Brand—proven by our work with Festivals2Go.',
    },
    
    {
        Id: '6',
        sImg: icon6,
        title: 'E-commerce Shield',
        slug: 'E-commerce-Shield',
        thumb1: 'Online',
        thumb2: 'Protection',
        description: 'Plug AllGuard into Shopify or any store for a payment layer that verifies users and shields you from fraud—custom-fit for your shop.',
    },
]

export default Services;